import React from 'react';
import './Header.css';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link } from 'react-router-dom';

const topheader = (props) => {
	return (
		<Navbar className="navbar-custom" expand="lg">
			<Navbar.Brand as={Link} to="/">
		      <img
		        src={require('./zurLogoReg.png')}
		        width="176"
		        height="24"
		        className="d-inline-block align-top"
		        alt="Zurado Corporation"
		      />
		    </Navbar.Brand>
		    <Navbar.Text className="font-italic" style={{'fontSize': '16px'}}>
		      IoT Sandbox
		    </Navbar.Text>
		  	<Navbar.Toggle aria-controls="basic-navbar-nav"/>
		  	<Navbar.Collapse id="basic-navbar-nav">
			    <Nav className="ml-auto">
			    	<Nav.Link as={Link} to="/">Home</Nav.Link>
			    	<Nav.Link as={Link} to="/details">Details</Nav.Link>
				    <NavDropdown title={props.device} id="basic-nav-dropdown">
				        <NavDropdown.Item href="#action/3.1">{props.device}</NavDropdown.Item>
			    	</NavDropdown>
			    </Nav>
		  	</Navbar.Collapse>
		</Navbar>
	);
}

export default topheader;
